export default {
	title: 'Scénarios',
	subtitle: 'Listez tous les scénarios possibles que vous évaluerez',
	no_description: 'Aucun scénario',

	context_worse: 'Négatif',
	context_best: 'Positif',

	tabs: {
		list: 'Liste',
		details: 'Détails',
		visualization: 'Visualisation',
		alt_title: 'Synthèse'
	}
};
